<template>
  <div class="reports-add-jobs">
    <div :class="{'add-desktop-obj': flag}">
      <el-button v-if="flag"
                 style="width: 100%"
                 :disabled="!!disabled || approve"
                 size="small" :class="['add', {disabled: this.approve}]" :type="isSelect ? 'default' : 'primary'"
                 @click="openDialog"
      >
        <span :class="[{disabled: this.approve}]"
              class="mob-show-create">{{ isSelect ? 'Сменить Объект' : '+ Выбрать Объект' }}</span>
        <span :class="[{disabled: this.approve}]" class="desktop-show-create">+ Объект</span>
      </el-button>
      <el-button v-else-if="!approve"
                 style="width: 100% !important;"
                 :disabled="!!disabled || approve"
                 size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
      >
        <span>{{ isSelect ? 'Сменить Объект' : '+ Выбрать Объект' }}</span>
      </el-button>
    </div>
    <add-jobs
      :isWorker="isWorker"
      :isObject="true"
      :approve="approve"
      :isEditable="true"
      @save="saveJob"
      @isInit="jobsInit"
      :isNotWorkSt="isNotWork"
      :user="user"
      :dirs="dirs"
      @mass-add="massAdd"
      @back-add="backAdd"
      :main-form="mainForm"
      @remove="() => {}"
      :workTypeOptions="work_type_options"
      :currentIndex="index"
      :options_works="options_works"
      ref="addJobs"/>
    <el-dialog
      @close="close" custom-class="add-obj-report-one" append-to-body title="Выбрать объект"
               :visible.sync="dialogObject">


      <div class="add-jobs" v-loading="loader || isLoading">
        <div style="margin-bottom: 18px" :class="['object-back', {'jobs-back-obj': isObjectList && selectParent}]">
          <div v-if="selectParent" @click="backObject()">
            <i class="el-icon-back"></i>
          </div>
          <div class="switch-mobile">
            <el-switch @change="switchChange" v-model="isObjectList">
            </el-switch>
            <strong>Иерархия</strong>
          </div>

          <div style="margin-left: 22px" class="switch-mobile">
            <el-switch @change="switchWork" v-model="isNotWork">
            </el-switch>
            <strong>Не выполнено</strong>
          </div>
          <div v-if="isObjectList && selectParent">
            <div class="circle-back" @click="backToMain">
              <i class="el-icon-arrow-up"></i>
            </div>
          </div>
        </div>

        <div style="display:flex; align-items: center;" class="input-search"
        >
          <el-checkbox

            style="margin-right: 12px; margin-left: 8px"
            @change="() => handleCheckbox(list, 'all1')" v-model="selectAll" v-show="!isObjectList"
          ></el-checkbox>
          <el-input placeholder="Поиск по объектам ..." v-model="search" clearable :class="['input-search']">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>

        <div style="display:flex; align-items: center;  margin-top: 8px" class="input-search-job"
        >
          <el-input
            v-if="!isObjectList && $store.state.project.object_job_search" placeholder="Поиск по работам ..."
            v-model="searchJobs"
            clearable :class="['input-search-job']">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <div class="jobs-ul" v-loading="loadingCheck">
          <div
            v-if="selectParent"
            @click="save(selectParent, true)"
            class="jobs-li"
          >
            <strong style="margin-left: 8px">{{ selectParent.name }}</strong>
          </div>
          <div
            v-show="(l.id !== 'all' || !selectParent) && isShow(l)"
            class="jobs-li" v-for="(l, index) in list" :key="index + l.id"
          >
            <el-checkbox @change="() => handleCheckbox(list[index], index)" v-model="list[index].isSelect"
                         style="margin-right: 8px" v-show="!isObjectList"
            ></el-checkbox>
            <span class="jobs-li-text" @click="save(l.id === 'all'? {} : l, l.id === 'all')">{{ l.name }}</span>
          </div>


          <div :class="['jobs-li link', {disabled: this.approve}]" v-if="role === 'admin'">
            <router-link to="/dashboard/objects">+ Добавить новый объект</router-link>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
      <el-button @click="close">Отмена</el-button>
      <el-button @click="massAdd(null)" type="primary">+ Добавить</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _, {orderBy} from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import dayjs from "dayjs";
import AddJobs from "./AddJobs";
import {toFixedWithoutZero} from "../../../../utils/numberUtils";

export default {
  name: 'AddObjects',
  components: {AddJobs},
  props: ['isSelect', 'confirmDisable', 'isWorker', 'disabled', 'approve', 'index', 'flag', 'report', 'inputObjects', 'mainForm', 'options_works', 'user', 'approve', 'isEditable', 'dirs'],
  data() {
    return {
      search: '',
      dialogObject: false,
      permissionUser: null,
      loadingCheck: false,
      unit: '',
      isLoading: true,
      loader: true,
      isNotWork: false,
      role: 'admin',
      selectParent: null,
      searchJobs: '',
      prevParent: [null],
      selectAll: false,
      work_type_options: [],
      isObjectList: false,
      list: [],
      form: {
        value: '',
        unit: '',
      },
    };
  },
  computed: {
    filteredList() {
      let result = this.list
      if (this.search) {
        result = result.filter(object => {
          return object.name.toLowerCase().includes(this.search.toLowerCase());
        });
      }
      if (this.searchJobs) {
        result = result.filter(object => {
          return object.searchJob.toLowerCase().includes(this.searchJobs.toLowerCase());
        });
      }


      return result
    },
  },

  async mounted() {
    this.selectParent = null;
    this.prevParent = [null]
    this.isObjectList = this.$store.state.project.object_list

    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);

    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id) || null);
    }

    if (this.isObjectList) {
      this.fetchByList();
    } else {
      await this.fetchTree();
    }


    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });

    const cxtJob = await this.fire()
      .collection('jobs')
      .where('type', '==', 'JOB').get()
    console.log('get jobs 7')

    const resultJob = []
    let result = JSON.parse(JSON.stringify(this.list))

    cxtJob.forEach((d) => {
      resultJob.push(d.data())
    })

    // cxtJob.forEach((d) => {
    result = result.map((d) => {
      let isNotWork = false
      const jobs = resultJob.filter((job) => job.objects.includes(d.id))
      jobs.forEach((data) => {
        if (Number(Number(data.totalValue || 0).toFixed(3)) < Number(Number(data.plan).toFixed(3))) {
          isNotWork = true
        }
      })

      d.isNotWork = isNotWork
      return d
    })


    if (!this.isObjectList && this.$store.state.project.object_job_search) {

      result = result.map((d) => {
        let searchStr = ''
        const jobs = resultJob.filter((job) => job.objects.includes(d.id))
        jobs.forEach((d) => {
          searchStr += d.name + ' ';
        })
        d.searchJob = searchStr.toLowerCase()
        return d
      })
    }


    this.list = JSON.parse(JSON.stringify(result))
  },

  methods: {
    jobsInit() {
      this.isLoading = false

    },
    switchWork() {

    },
    isShow(obj) {
      if (this.isNotWork) {
        return this.filteredList.find((d) => d.isNotWork && d.id === obj.id)
      } else {
        return this.filteredList.find((d) => d.id === obj.id)
      }
    },
    switchChange(flag) {
      if (flag) {
        this.fetchByList()
      } else {
        this.fetchTree()
      }
    },
    backObject() {
      this.selectParent = this.prevParent[this.prevParent.length - 1]
      if (this.prevParent.length > 1) {
        this.prevParent.pop()
        this.prevParent = [...this.prevParent]
      }
      this.fetchByList(this.selectParent ? this.selectParent.id : null);
    },
    backToMain() {
      this.selectParent = null
      this.prevParent = [null]
      this.fetchByList(null);
    },
    fire() {
      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    async fetchByList(parentId = null) {
      this.loader = true;
      const result = [];

      this.fire()
        .collection('objects')
        .where('parentId', '==', parentId)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              isSelect: false,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(async () => {
        if (!result.length) {
          let objectName = ''
          this.prevParent.forEach((obj) => {
            if (obj) {
              if (objectName) {
                objectName = objectName + ' > ' + obj.name
              } else {
                objectName = obj.name

              }
            }
          })


          // this.$emit('add-objects', {
          //   name: objectName ? (objectName + ' > ' + this.selectParent.name) : this.selectParent.name,
          //   id: this.selectParent.id,
          // });
          // this.close();

          const obj = {
            name: objectName ? (objectName + ' > ' + this.selectParent.name) : this.selectParent.name,
            id: this.selectParent.id,
            code: this.selectParent.code || null,
            jobs: [],
            // id: object.id || null,
          }
          await this.$refs.addJobs.open(null, null, null, obj)
          await this.$refs.addJobs.setSearch(this.searchJobs)
          // setTimeout(() => {
          //   this.$refs.addJobs.setAllSelect(obj.jobs.length ? obj.jobs : null)
          // }, 500)
        }


        result.push({
          name: 'Без объекта',
          isSelect: false,
          id: 'all'
        })


        this.list = _.orderBy(filterObjects(filterObjects(result, this.permission), this.permissionUser), 'index', ['asc']);
        this.loader = false;
      }).catch((e) => {
        console.error(e)
        this.loader = false;
      });
    },
    async timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async handleCheckbox(d, index) {
      if (index === 'all1') {
        this.loadingCheck = true;
        // this.selectAll = !this.selectAll

        this.filteredList.forEach((s) => {
          const index = this.list.findIndex((obj) => s.id === obj.id && (!this.isNotWork || obj.isNotWork))
          try {

            if (index !== -1) {
              this.list[index].isSelect = this.selectAll
              this.list[index].jobs = []
            }
          } catch (e) {
          }
        })

        if (this.selectAll) {
          for (let obj of this.list) {
            if (obj.isSelect) {
              this.loadingCheck = true;
              await this.$refs.addJobs.open(null, 1, 1, obj, true)
              await this.timeout(100)
              // await setTimeout(() => {
              this.$refs.addJobs.setAllSelect(null, true)
              this.$refs.addJobs.saveToReport(true)
              this.loadingCheck = false;
            }
            // }, 1000)
          }

        }


        this.loadingCheck = false;

        return
      }

      if (d.isSelect) {
        this.loadingCheck = true;
        console.log('1 JOB')
        await this.$refs.addJobs.open(null, 1, 1, d, true)
        await this.timeout(100)
        console.log('4 JOB')
        this.$refs.addJobs.setAllSelect(null, true)
        this.$refs.addJobs.saveToReport(true)
        this.loadingCheck = false;
      } else {
        d.jobs = []
      }
      this.list = JSON.parse(JSON.stringify([...this.list]))

    },
    fetchTree() {
      return new Promise((resolve, reject) => {
        this.loader = true;

        const result = [];


        const path = 'OBJECT_' + this.fire().path


        const cache = localStorage.getItem(path);


        if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
          this.fire()
            .collection('objects')
            .get()
            .then((data) => {
              data.forEach((subDoc) => {
                const data = subDoc.data();
                result.push({
                  id: subDoc.id,
                  name: data.name,
                  objects: data.objects, code: data.code,
                  isSelect: false,
                  index: data.index,
                  parentId: data.parentId || undefined,
                  isParent: data.isParent,
                });
              });
            }).finally(() => {
            // if(isCache) {
            localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
            // }

            result.push({
              name: 'Без объекта',
              isSelect: false,
              id: 'all'
            })
            this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);
            this.loader = false;
            resolve()
          }).catch(() => {
            this.loader = false;
            reject()
          });
        } else {

          const result = JSON.parse(cache).result
          result.push({
            name: 'Без объекта',
            isSelect: false,
            id: 'all'
          })
          this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);
          this.loader = false;
          resolve()
        }
      })
    },
    openDialog() {

      if (this.confirmDisable) {
        this.$emit('add-objects', null);
        return this.dialogObject = true;
      }
      if (this.isSelect && this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF') {
        this.$confirm('После смены объекта вся введенная информация по работам будет удалена, продолжить?', 'Подтверждение', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.selectParent = null;
          this.prevParent = [null]
          if (this.isObjectList) {
            this.fetchByList()
          }
          this.$emit('add-objects', null);
          this.dialogObject = true;
        });
      } else {
        this.$emit('add-objects', '');
        this.dialogObject = true;
      }
    },
    backAdd(d) {
      d.obj.jobs = d.result
      const objIndex = this.list.findIndex((l) => l.id === d.obj.id)
      console.log(objIndex, 'objIndex')
      if (objIndex !== -1 && d.obj.jobs.length) {
        this.list[objIndex] = {...this.list[objIndex], ...d.obj}
        this.list[objIndex].isSelect = true

        this.list = [...this.list]
      } else if (objIndex !== -1) {
        this.list[objIndex].jobs = []

        this.list[objIndex].isSelect = false
      }

    },
    saveJob(d) {
      d.obj.jobs = [d.form]
      this.$emit('add-objects', d.obj);
      this.close();
    },
    massAdd(d) {
      const result = [...this.list]
      if (d) {

        d.obj.jobs = d.result
        d.obj.isSelect = true

        result.push(d.obj)
      }

      let uniqueById = Array.from(
        new Map(result.filter((s) => s.isSelect).map(item => [item.id, item])).values()
      );


      uniqueById.map((d) => {
        d.jobs = d.jobs.map((job) => {
          if (job.volumes) {
            job.daily_plan = toFixedWithoutZero(job.volumes.length ? job.volumes[this.mainForm.turn.value - 1][datetime] : '')
          }
          return job
        })


        return d

      })

      orderBy(uniqueById, 'index', 'asc').forEach((d) => {
        this.$emit('add-objects', d);
      })


      this.close();


    },
    async save(object, isflag) {

      if (this.isObjectList && !isflag) {
        if (this.selectParent) {
          this.prevParent.push(JSON.parse(JSON.stringify(this.selectParent)))
        }
        this.selectParent = object
        this.fetchByList(this.selectParent.id)
      } else {
        const obj = {
          name: object.name || 'Без объекта',
          index: this.index || 0,
          code: object.code || null,
          jobs: object.jobs,
          id: object.id || null,
        }
        await this.$refs.addJobs.open(null, null, null, obj)
        await this.$refs.addJobs.setSearch(this.searchJobs)
        setTimeout(() => {
          this.$refs.addJobs.setAllSelect(obj && obj.jobs && obj.jobs.length ? obj.jobs : null)
        }, 500)
      }
    },
    close() {
      this.dialogObject = false;

      if (this.isObjectList) {
        this.backObject()
      }

      this.list = this.list.map((d) => {
        d.isSelect = false
        d.jobs = []
        return d
      })

      // this.fetchByList( null);

      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
    },
  },
};
</script>

<style lang="scss">


.add-obj-report-one {
  .radioMargin {
    margin-left: 32px;
    width: calc(100% - 32px);
    margin-top: 8px
  }

  .el-dialog__footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding-bottom: 8px;
    padding-top: 3px;
    z-index: 100;
    @media screen and (max-width: 500px) {
      padding: 4px;
    }
  }

  .el-dialog__body {
    padding-top: 0 !important;

    @media screen and (max-width: 500px) {
      padding-left: 4px !important;
      padding-right: 8px !important;

      .add-jobs .jobs-li {
        padding-left: 4px !important;
      }
      .object-back {
        top: 47px !important;
        margin-top: 0px;
        width: 100%;
        background: white;
        padding-bottom: 8px;
        margin-left: 0px !important;
        padding-left: 10px;
      }

      .jobs-back-obj {
        .switch-mobile {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }

      .input-search {
        top: 86px;
      }

    }

  }

  .input-search {
    position: sticky;
    top: 54px;
    z-index: 100;
    background: #fff;
  }

  .el-dialog__header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 99;
  }

  .object-back {
    margin-top: -32px;
    z-index: 100;
    position: sticky;
    margin-right: 32px;
    top: 20px;
    margin-left: 158px;
  }

  .jobs-back-obj.object-back {
    margin-left: 0;
    margin-top: 0px;
    margin-bottom: 0 !important;
    background: #fff;
    width: calc(100% - 30px) !important;

    .circle-back {
      right: -5px !important;
    }
  }
}

.circle-back {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  border: 1px solid grey;
  display: flex;
  flex-direction: column;
  position: absolute;
  align-items: center;
  justify-content: center;
  right: 20px;
  margin-top: -20px;
  cursor: pointer;

  .el-icon-arrow-up {
    margin-bottom: 2px;
  }
}

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    .jobs-li-text {
      display: flex;
      align-items: center;
      padding-bottom: 2px;
      min-height: 46px;
      flex: 1;

    }


    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.object-back {
  display: flex;
  align-items: center;

  .el-icon-back {
    width: 50px;
    cursor: pointer;
  }

  i {
    font-size: 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOneComplete/components/AddObjects.vue